import type FontFamilyBoldStyles from './types';

const singleBold: FontFamilyBoldStyles = 'ExpensifyNeue-Regular';
const multiBold: FontFamilyBoldStyles = 'ExpensifyNeue-Regular, Segoe UI Emoji, Noto Color Emoji';

export {singleBold, multiBold};
